import React from "react";
import { NavLink } from "react-router-dom";
import { Scale, ShieldCheck, FileCheck, Cookie, Database, FileSignature } from "lucide-react";

const TABS = [
    { to: "/terms", label: "Terms of Service", Icon: Scale, testId: "legal-tab-terms" },
    { to: "/privacy", label: "Privacy Policy", Icon: ShieldCheck, testId: "legal-tab-privacy" },
    { to: "/cookies", label: "Cookies", Icon: Cookie, testId: "legal-tab-cookies" },
    { to: "/subprocessors", label: "Subprocessors", Icon: Database, testId: "legal-tab-subprocessors" },
    { to: "/dpa", label: "DPA", Icon: FileSignature, testId: "legal-tab-dpa" },
    { to: "/verification-consent-policy", label: "Verification & AI Consent", Icon: FileCheck, testId: "legal-tab-consent" },
];

export const LegalTabs = () => (
    <div className="mx-auto max-w-4xl px-6 mt-4 mb-8" data-testid="legal-tabs">
        <div className="inline-flex flex-wrap gap-1 rounded-full border border-border bg-muted/40 p-1">
            {TABS.map(({ to, label, Icon, testId }) => (
                <NavLink
                    key={to}
                    to={to}
                    end
                    data-testid={testId}
                    className={({ isActive }) =>
                        `inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${isActive ? "bg-brand-navy text-white" : "text-foreground/70 hover:bg-background"}`
                    }
                >
                    <Icon size={12} /> {label}
                </NavLink>
            ))}
        </div>
    </div>
);

export default LegalTabs;
